import { extendObservable } from "mobx";
import { observer } from "mobx-react-lite";
import * as React from "react";

import { MfAttrEditor } from "../components/MfAttrEditor";
import { MfPath } from "../MFormTypes";
import { createValidators, MfValidator } from "../validators";
import { ZMfNodeAttr } from "../ZMfNode";
import { createMfNodeBase } from "./createMfNodeBase";
import { isEqualFieldValues } from "./isEqualFieldValues";
import { MfNode, PropsRender } from "./MfNode";

export interface MfNodeAttr extends MfNode {
  attrValue: unknown;
  initialValue: unknown;
  validators: MfValidator[];
}

export const createMfNodeAttr = (
  meta: ZMfNodeAttr,
  ownerDataPath: MfPath,
): MfNodeAttr => {
  const attrName = meta.attr.name;
  const dataPath = [...ownerDataPath, attrName];
  let onActive: (() => void) | undefined;
  const ctrl: MfNodeAttr = extendObservable(createMfNodeBase(meta), {
    meta,
    Render: observer(({ ctx }: PropsRender) => (
      <MfAttrEditor
        attrMeta={meta.attr}
        value={ctrl.value}
        onChange={(v) => {
          ctrl.setValue(v);
          ctx.onChange(ctrl);
        }}
        node={ctrl}
        ctx={ctx}
        activateCallback={(fn) => {
          onActive = fn;
        }}
      />
    )),
    attrValue: null as unknown,
    setValue(newValue: unknown) {
      if (meta.attr.type.name === "boolean") {
        // костыль из-за MDM2-1047. По каким-то праноидальным причинам решено запретить использование null для логического типа
        this.attrValue = newValue ?? false;
      } else {
        this.attrValue = newValue;
      }
    },
    get value() {
      return this.attrValue;
    },
    get key() {
      return attrName;
    },
    get dataKey() {
      return attrName;
    },
    dataPath,
    get title() {
      return meta.attr.title;
    },
    validators: createValidators(meta.attr),
    colSpan: meta.attr.edit?.colSpan,
    newLine: meta.attr.edit?.newLine,
    activate: async () => {
      onActive?.();
    },

    initialValue: null as unknown,
    setAsUnchanged() {
      this.initialValue = this.attrValue;
    },
    get isChanged(): boolean {
      return !isEqualFieldValues(this.attrValue, this.initialValue);
    },
  });
  return ctrl;
};
